var chunkToChildrenMap = {
	"extensions_cornerstone-dicom-sr_src_index_tsx": [
		"extensions_cornerstone-dicom-sr_src_viewports_OHIFCornerstoneSRViewport_tsx"
	],
	"extensions_default_src_Panels_PanelMeasurementTable_tsx-extensions_default_src_index_ts-exten-0d0cf0": [
		"extensions_cornerstone-dicom-sr_src_viewports_OHIFCornerstoneSRViewport_tsx"
	],
	"extensions_cornerstone_src_index_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_measurement-tracking_src_index_tsx": [
		"extensions_cornerstone-dicom-sr_src_viewports_OHIFCornerstoneSRViewport_tsx",
		"extensions_measurement-tracking_src_viewports_TrackedCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-seg_src_index_tsx": [
		"extensions_cornerstone-dicom-seg_src_viewports_OHIFCornerstoneSEGViewport_tsx",
		"extensions_cornerstone-dicom-sr_src_viewports_OHIFCornerstoneSRViewport_tsx"
	],
	"extensions_dicom-pdf_src_index_tsx": [
		"extensions_dicom-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx"
	],
	"extensions_dicom-video_src_index_tsx": [
		"extensions_dicom-video_src_viewports_OHIFCornerstoneVideoViewport_tsx"
	],
	"extensions_cornerstone-dicom-rt_src_index_tsx": [
		"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx"
	],
	"custom-extensions_cornerstone-vidaa_src_index_tsx": [
		"custom-extensions_cornerstone-vidaa_src_viewports_OHIFCornerstoneVIDAAViewport_tsx"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));